(() => {
  'use strict';

  if (customElements.get('pt-benefits-scene')) return;

  class BenefitsScene extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.items = [...this.querySelectorAll('.pt-benefits__list li')];
      this.classList.add('is-enhanced');

      if (this.reducedMotion.matches) {
        this.items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      }, { threshold: 0.35, rootMargin: '0px 0px -16% 0px' });
      this.items.forEach((item) => this.observer.observe(item));
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  }

  customElements.define('pt-benefits-scene', BenefitsScene);
})();
